import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  AbstractFilterElementComponent,
  FilterEmitterType,
} from './abstract-filter-element.component';
import {
  FilterElementSize,
  gridClassesForFilterElementSize,
  ResultFieldOption,
} from './filter-elements';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FluidModule } from 'primeng/fluid';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'result-field-filter-element',
  templateUrl: './result-field-filter-element.component.html',
  imports: [
    FormsModule,
    TranslatePipe,
    FloatLabelModule,
    FluidModule,
    SelectModule,
    InputTextModule,
  ],
  styles: `
    :host ::ng-deep .p-inputtext {
      padding: 6px 12px;
    }
  `,
})
export class ResultFieldFilterElementComponent
  extends AbstractFilterElementComponent
  implements OnChanges
{
  @HostBinding('class')
  override componentClass = '';

  @Input()
  override size: FilterElementSize = FilterElementSize.LARGE;

  @Input()
  override label: string | undefined;

  @Input()
  override filterActive = false;

  @Input()
  override filterKey!: string;

  @Input()
  fields: ResultFieldOption[] = [];

  @Input()
  fieldPlaceholder = 'filter.result-field.select-field';

  @Input()
  valuePlaceholder = 'filter.result-field.enter-value';

  @Output()
  override filterTerm: EventEmitter<FilterEmitterType> = new EventEmitter();

  /**
   * Emits when a result field filter is applied.
   * Format: { field: string, value: string } or null when cleared
   */
  @Output()
  resultFilterChange: EventEmitter<{ field: string; value: string } | null> =
    new EventEmitter();

  selectedField: string | null = null;
  searchValue = '';

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.componentClass = gridClassesForFilterElementSize(
        changes['size'].currentValue,
      );
    }
  }

  override onFilterChange(_changes: unknown): void {
    this.applyFilter();
  }

  onFieldChange(): void {
    // When field changes, re-apply filter if there's a value
    if (this.searchValue) {
      this.applyFilter();
    }
  }

  onValueChange(): void {
    this.applyFilter();
  }

  private applyFilter(): void {
    if (this.selectedField && this.searchValue.trim()) {
      const filterValue = `${this.selectedField}:contains:${this.searchValue.trim()}`;
      this.filterTerm.emit({ key: this.filterKey, term: filterValue });
      this.resultFilterChange.emit({
        field: this.selectedField,
        value: this.searchValue.trim(),
      });
    } else {
      this.filterTerm.emit({ key: this.filterKey, term: undefined });
      this.resultFilterChange.emit(null);
    }
  }

  clearFilter(): void {
    this.selectedField = null;
    this.searchValue = '';
    this.filterTerm.emit({ key: this.filterKey, term: undefined });
    this.resultFilterChange.emit(null);
  }
}
